import styled from 'styled-components';
import { Card, Divider } from 'antd';

export const StyledCard = styled(Card)`
  border-radius: 16px;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.04);
  border: 1px solid #e8e8e8;
`;

export const InfoBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  .anticon {
    color: #1890ff;
    font-size: 18px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }
`;

export const StyledDivider = styled(Divider)`
  margin: 24px 0;
`;

export const FeesCard = styled(Card)`
  background: #fafafa;
  margin-top: 16px;
`;

export const FeeBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;

  .fee-icon {
    color: #52c41a;
    font-size: 18px;
  }

  .fee-amount {
    font-weight: 600;
    color: #52c41a;
  }
`;

